var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationCircleBiportal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6498_10690)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.68661 0 0 2.68661 0 6C0 9.31339 2.68661 12 6 12C9.31339 12 12 9.31339 12 6C12 2.68661 9.31339 0 6 0ZM6 10.9821C3.24911 10.9821 1.01786 8.75089 1.01786 6C1.01786 3.24911 3.24911 1.01786 6 1.01786C8.75089 1.01786 10.9821 3.24911 10.9821 6C10.9821 8.75089 8.75089 10.9821 6 10.9821Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35742 8.35714C5.35742 8.52764 5.42515 8.69115 5.54571 8.81171C5.66627 8.93227 5.82978 9 6.00028 9C6.17078 9 6.33429 8.93227 6.45485 8.81171C6.57541 8.69115 6.64314 8.52764 6.64314 8.35714C6.64314 8.18665 6.57541 8.02313 6.45485 7.90257C6.33429 7.78202 6.17078 7.71429 6.00028 7.71429C5.82978 7.71429 5.66627 7.78202 5.54571 7.90257C5.42515 8.02313 5.35742 8.18665 5.35742 8.35714ZM5.67885 6.85714H6.32171C6.38064 6.85714 6.42885 6.80893 6.42885 6.75V3.10714C6.42885 3.04821 6.38064 3 6.32171 3H5.67885C5.61992 3 5.57171 3.04821 5.57171 3.10714V6.75C5.57171 6.80893 5.61992 6.85714 5.67885 6.85714Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6498_10690"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationCircleBiportal);
export default __webpack_public_path__ + "static/media/ExclamationCircleBiportal.c0535fa5092deabe5cb36904b1d9f852.svg";
export { ForwardRef as ReactComponent };